<template>
  <div class="fixed-banner">
    <drawer :isActive="showDrawer" @closed="showDrawer = false"></drawer>
    <div class="container-fluid mobile-banner" :style="getTitleBarStyle">
      <div class="row align-items-center">
        <div class="col-1 shop-title" v-if="showLoginButton">
          <router-link
            to="/"
            :class="isRolldStore() ? 'rolld-primary-color' : getMenuIconStyle"
          >
            <span @click.prevent="hClick" class="material-icons md-36"
              >menu</span
            >
          </router-link>
        </div>
        <div
          v-if="getLogo"
          :class="{
            'col-2': true,
            'intro-header-logo': true,
            'center-logo': !showLoginButton,
          }"
          :style="logoContainerStyles"
        >
          <img :src="getLogo" class="logo" alt="logo" />
        </div>
        <div class="col-5 cart" v-if="showCart">
          <span class="cart">
            <router-link
              :to="{
                name: 'shoppingcartmobile',
                params: {
                  storeid: currentstore,
                  storename: $route.params.storename,
                },
              }"
            >
              <span class="cart-cost">{{
                cartValue | formatMoney(currencySign)
              }}</span>
              <span class="material-icons md-36">shopping_cart</span>
            </router-link>
          </span>
        </div>
      </div>
    </div>

    <div class="introimg" style="height: 20vh; background-repeat: no-repeat; background-size: cover;"   :style="{ 'background-image': headAbsolute }">
    </div>

    <!-- /banner -->
    <!-- <div class="container-fluid category-naviagtion intro" :style="getStyle()">
      <div class="row">
        <ul class="store-menu-mobile">
          <li class>
            <a :style="mobileStyles.navText" href="#">{{ $t("message.orderOnline") }}</a>
          </li>
        </ul>
      </div>
    </div> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Drawer from "../shared/drawer";
import {
  IsStoreOpenAtTime,
  getCurrentDate,
} from "./../../api/helpers/datetimeHelper.js";
import { DetectBrand } from "../../mixins/brandDetector";

export default {
  name: "IntroHeaderMobile",
  components: {
    Drawer,
  },
  data() {
    return {
      showDrawer: false,
    };
  },
  computed: {
    ...mapGetters([
      "cartValue",
      "currentstore",
      "mobileStyles",
      "currentStoreDoc",
      "hqDoc",
      "currencySign",
    ]),
    showLoginButton() {
      return (
        this.hqDoc &&
        this.hqDoc.ViewComponentConfigs &&
        this.hqDoc.ViewComponentConfigs.LogIn === true &&
        DetectBrand.methods.isBranded() === true
      );
    },
    showCart() {
      var storeOpen = false;
      if (this.currentStoreDoc) {
        var now = getCurrentDate(this.currentStoreDoc.TimezoneIanaFormat);
        storeOpen = IsStoreOpenAtTime(
          this.currentStoreDoc.BlackoutDates,
          this.currentStoreDoc.OperatingHours,
          this.currentStoreDoc.IsInOperation,
          now
        );
      }
      if (
        this.$route.name &&
        this.$route.name.toLowerCase().indexOf("mainpage") < 0 &&
        this.$route.name.toLowerCase().indexOf("notfoundpage") < 0 &&
        storeOpen
      )
        return true;
      return false;
    },
    getLogo() {
      if (this.isRolldStore()) {
        return this.hqDoc ? this.hqDoc.Logo : null;
      }
      return null;
    },
    getTitleBarStyle() {
      return this.mobileStyles.TitleBar;
    },
    getMenuIconStyle() {
      return this.mobileStyles.navText;
    },

    logoContainerStyles() {
      return this.getLogo ? "min-height: 100px" : "max-height: 0";
    },

    headAbsolute() {
      if (this.hqDoc && this.hqDoc.ProfileImage) {
        return `url(${this.hqDoc.ProfileImage})`;
      }
      return ''
    },
  },
  methods: {
    hClick() {
      this.showDrawer = true;
    },
    getStyle() {
      var styles = [];
      styles.push(this.mobileStyles.primaryBackgroundColour);
      return styles;
    },
  },
};
</script>
